import React from 'react';

// Loading Spinner Component - Single Responsibility Principle
const LoadingSpinner = ({ size = 'medium', color = 'gray' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  const colorClasses = {
    gray: 'text-gray-600',
    white: 'text-white',
    black: 'text-gray-900'
  };

  return (
    <div className="flex justify-center items-center p-4">
      <div 
        className={`
          ${sizeClasses[size]} 
          ${colorClasses[color]} 
          animate-spin
        `}
      >
        <svg 
          className="w-full h-full" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          />
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
    </div>
  );
};

export default LoadingSpinner;